// Interface

import util from '@/utils/classToObject'
import { IAdministrationState } from './state'

export class AdministrationGetter {

    //////////////////////////////////////////////////////////////////
    // SEJOUR
    /////////////////////////////////////////////////////////////////
    public sejourStatus(state: IAdministrationState) {
        return state.sejourStatus
    }
    public sejourDic(state: IAdministrationState) {
        return state.sejourDic
    }
    public sejourList(state:IAdministrationState){
        return state.sejourList.item.map( id => state.sejourDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

    //////////////////////////////////////////////////////////////////
    // USER
    /////////////////////////////////////////////////////////////////
    public userStatus(state: IAdministrationState) {
        return state.userStatus
    }
    public userDic(state: IAdministrationState) {
        return state.userDic
    }
    public userList(state:IAdministrationState){
        return state.userList.item.map( id => state.userDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  


    //////////////////////////////////////////////////////////////////
    // COMMANDE
    /////////////////////////////////////////////////////////////////
    public commandeStatus(state: IAdministrationState) {
        return state.commandeStatus
    }
    public commandeDic(state: IAdministrationState) {
        return state.commandeDic
    }
    public commandeList(state:IAdministrationState){
        return state.commandeList.item.map( id => state.commandeDic[id] )
    }  

    //////////////////////////////////////////////////////////////////
    // MAIL_TEMPLATE
    /////////////////////////////////////////////////////////////////
    public mailTemplateStatus(state: IAdministrationState) {
        return state.mailTemplateStatus
    }
    public mailTemplateDic(state: IAdministrationState) {
        return state.mailTemplateDic
    }
    public mailTemplateList(state:IAdministrationState){
        return state.mailTemplateList.item.map( id => state.mailTemplateDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

    //////////////////////////////////////////////////////////////////
    // MAIL_SKIN
    /////////////////////////////////////////////////////////////////
    public mailSkinStatus(state: IAdministrationState) {
        return state.mailSkinStatus
    }
    public mailSkinDic(state: IAdministrationState) {
        return state.mailSkinDic
    }
    public mailSkinList(state:IAdministrationState){
        return state.mailSkinList.item.map( id => state.mailSkinDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    } 
    
    //////////////////////////////////////////////////////////////////
    // PAN_STATUS
    /////////////////////////////////////////////////////////////////
    public panStatusStatus(state: IAdministrationState) {
        return state.panStatusStatus
    }
    public panStatusDic(state: IAdministrationState) {
        return state.panStatusDic
    }
    public panStatusList(state:IAdministrationState){
        return state.panStatusList.item.map( id => state.panStatusDic[id] ).sort((a,b) => a.libelle.localeCompare(b.libelle) )
    }  

}

export default util.classToObject(AdministrationGetter)